import api from './api';

export const getEspecialidadesPorEstabelecimento = async (estabelecimentoId) => {
  const { data } = await api.get(`/especialidades/estabelecimento/${estabelecimentoId}`);
  return data;
};
